import { To, useResolvedPath } from "react-router-dom";

export const useResolvedUrl = (to: To) => {
  const path = useResolvedPath(to);
  const result = new URL(path.pathname, window.location.href);
  result.search = path.search;
  result.hash = path.hash;
  return result;
};
